<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('employeeProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('employeeProfile.pageTitle'),
            href: '/admin/employees',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-3">
          <Photo v-model="model" :validate="errors" />
        </div>
        <div class="col-md-9">
          <ts-card>
            <ts-card-wrapper>
              <Employment v-model="model" :validate="errors" />
              <Address v-model="model" :validate="errors" class="ts-mt-4" />
              <SocialSecurityNumber v-model="model" :validate="errors" class="ts-mt-4" />
							<div class="row">
								<div class="col-md-6"></div>
								<div class="col-md-6">
									<div class="row">
										<label class="col-md-4"></label>
										<div class="col-md-7 ts-w-full ts-flex ts-justify-end ts-space-x-4 ts-mt-4">
                      <ts-button
                        @click.prevent="$router.push({ name: 'em-profile' })"
                      >{{ $t('cancel') }}</ts-button>
											<ts-button
												color="primary"
												:waiting="waiting"
												@click.prevent="onUpdate"
											>{{ $t('update') }}</ts-button>
										</div>
									</div>
								</div>
							</div>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import Photo from './components/photo'
import Employment from './components/employment'
import Address from './components/address'
import SocialSecurityNumber from './components/socail-security-number'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'employeeProfileEdit',
  components: {
    Photo,
    Employment,
		Address,
		SocialSecurityNumber
  },
  data() {
    return {
      loading: false,
      waiting_new: false,
      waiting: false,
      errors: new Errors(),
      model: {
        employee_id: 0,
        card_id: null,
        employee_name_kh: null,
        employee_name_en: null,
        sex: 'male',
        phone: null,
        email: null,
        address: null,
        photo: null,
        employment_date: null,
        probation_end_date: null,
        position_id: null,
        department_id: null,
        status_id: null,
        status_effective_date: null,
        nationality: null,
        ssn_no: null,
        ssn_issued_date: null,
        ssn_expiry_date: null,
        ssn_issued_at: null,
        date_of_birth: null
      }
    }
	},
	computed: {
		...mapState('employee/profile', ['edit_data'])
	},
  methods: {
		...mapActions('employee/profile', ['position', 'department', 'upload', 'find', 'update']),
		async fetchData(){
			this.loading = true
			await this.position()
			await this.department()
			await this.find(this.$route.params.id)
			this.setEditData()
			this.loading = false
		},
		async uploadPhoto(id){
			if((this.file instanceof File) || this.file instanceof Blob){
				let formData = new FormData()
        formData.append('photo', this.file)
        let response = await this.upload({
					id: id,
					data: formData
				})
			}
		},
		onUpdate() {
			let { photo, ...dataSend } = this.model
			this.file = photo
			this.waiting = true
			this.errors = new Errors()
      this.update({
					id: this.model.employee_id,
					data: dataSend
				})
        .then(async response => {
					await this.uploadPhoto(response.id)
					this.$toasted.success(response.message)
					this.$router.push({ name: 'em-profile'})
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
		},
		setEditData(){
			this.model.employee_id = this.edit_data.employee_id
      this.model.card_id = this.edit_data.card_id
      this.model.employee_name_kh = this.edit_data.employee_name_kh
      this.model.employee_name_en = this.edit_data.employee_name_en
      this.model.sex = this.edit_data.sex
      this.model.phone = this.edit_data.phone
      this.model.email = this.edit_data.email
      this.model.address = this.edit_data.address
      this.model.photo = this.edit_data.photo
      this.model.employment_date = this.edit_data.employment_date
      this.model.probation_end_date = this.edit_data.probation_end_date
      this.model.position_id = this.edit_data.position_id
      this.model.department_id = this.edit_data.department_id
      this.model.status_id = this.edit_data.status_id
      this.model.status_effective_date = this.edit_data.status_effective_date
      this.model.nationality = this.edit_data.nationality
      this.model.ssn_no = this.edit_data.ssn_no
      this.model.ssn_issued_date = this.edit_data.ssn_issued_date
      this.model.ssn_expiry_date = this.edit_data.ssn_expiry_date
      this.model.ssn_issued_at = this.edit_data.ssn_issued_at
			this.model.date_of_birth = this.edit_data.date_of_birth
		}
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('employee/profile/SET_EDIT_DATA', {})
    this.$store.commit('employee/profile/CLEAR_SETUP')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>